import React from 'react';
import withStyles from 'isomorphic-style-loader/withStyles';
import Skeleton from '../../../../Common/Skeleton/Skeleton';
import s from './CitySectionSwiperSkeleton.css'

function CitySectionSwiperSkeleton() {
    return (
        <div className={s.categorySkeletonList}>
            {[1, 2, 3, 4, 5, 6, 7].map(n => {
                return (
                    <div key={n} className={s.categorySkeletonListItem}>
                        <Skeleton className={s.categorySkeletonImg} />
                        <Skeleton className={s.categorySkeletonContent} />
                    </div>
                )
            })}
        </div>
    );
}

export default withStyles(s)(CitySectionSwiperSkeleton);
